const prefix = "USER";

export const USER_FETCH_LOADING = `${prefix}_FETCH_LOADING`;
export const USER_FETCH_SUCCESS = `${prefix}_FETCH_SUCCESS`;
export const USER_FETCH_FAILURE = `${prefix}_FETCH_FAILURE`;